import type { ComponentNameAndModule } from '@sitecore-jss/sitecore-jss-angular';

const loadChildren = () =>
  import('./blog.lazy.module').then((mod) => mod.BlogLazyModule);

const components = ['BlogOverview', 'BlogCategoryOverview'];

export const blogLazyImports: ComponentNameAndModule[] = components.map(
  (name) => ({
    path: name,
    loadChildren,
  })
);
